<template>
  <div class="pie-box">
    <div class="pie-flx">
      <template v-if="data.rows.length">
        <Vchart :option="echartData" />
      </template>
      <template v-else>
        <emptyTip />
      </template>
    </div>
  </div>
</template>

<script>
import { getPieOption } from "./config";
import emptyTip from "./empty.vue";
import Vchart from "@c/Vchart.vue";
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        rows: [],
        columns: []
      })
    }
  },
  computed: {
    echartData() {
      return getPieOption(this.data.columns, this.data.rows);
    }
  },
  components: {
    Vchart,
    emptyTip
  }
};
</script>

<style>
.pie-box {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.pie-flx {
  width: 458px !important;
  height: 100%;
  /* position: absolute;
  left: 50%;
  margin-left: -287px; */
}
</style>
